/**
 * Persists Comment RPA modal data for the parent order and linked siblings.
 * @module commentRpaModalSaveForOrderIds
 */
import { resolveLinkedOrderUpdateOrderIds } from "../../utils/resolveLinkedOrderUpdateOrderIds";
import { commentRpaModalSave } from "./commentRpaModalSave";

/** Payload for {@link commentRpaModalSave} excluding the target order id. */
export type CommentRpaModalSaveBasePayload = Omit<
  Parameters<typeof commentRpaModalSave>[0],
  "order_id"
>;

/**
 * Posts the same Comment RPA payload for each target order id in parallel.
 *
 * @param basePayload - BO status and optional write-back fields for every order
 * @param parentOrderId - Current order being marked complete
 * @param selectedOrderIds - Optional linked sibling order ids from the modal
 * @returns Resolves when every save request completes
 */
export const markOrderAsCompleted = async (
  basePayload: CommentRpaModalSaveBasePayload,
  parentOrderId: string,
  selectedOrderIds?: string[],
): Promise<void> => {
  const orderIdsToUpdate = resolveLinkedOrderUpdateOrderIds(
    parentOrderId,
    selectedOrderIds,
  );
  await Promise.all(
    orderIdsToUpdate.map((order_id) =>
      commentRpaModalSave({
        ...basePayload,
        order_id,
      }),
    ),
  );
};
